componentRegistryInstance.register('collapsible', 'read', 'hrd.components.form.CollapsibleComponent');

hrd.components.form.CollapsibleComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.CollapsibleComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, klass);

		$(field).attr('data-as-label', 'true');

		$.timeout(0)
			.then(() => {
				const $field = $(field);
				const initialState = $field.data('state');

				$field
					.addClass('ui-helper-hidden-invisible')
					.attr('data-state', 'open');

				$field.prop('style').setProperty('--height', `${$field.outerHeight()}px`);

				if(initialState) {
					$field.attr('data-state', initialState);
				} else {
					$field.removeAttr('data-state');
				}

				$field.removeClass('ui-helper-hidden-invisible');
			});
	},
	getReadOnlyField: function(field, name, object, options) {
		// do nothing: do not call 'super'
	},
	setReadOnlyField: function(field, value, object, options) {
		// do nothing: do not call 'super'
	},
	resetReadOnlyField: function(field, options) {

	},
});